import cookies from "js-cookie";
import storageManifest from "../../../../storageManifest.json";
import { storageCanBeSet } from "@JohnLewisPartnership/pecr-util";
import {
  CurtainConfiguration,
  RomanBlindConfiguration,
  LiningWeight,
  HeadingType,
  StackingStyle,
} from "../configurationTypes";
import { M2M_CURTAINS_DEFAULT_EYELET_COLOUR } from "./constants";

const m2mCurtainsCookieName = "m2mCurtainChoices";
const m2mRomanBlindsCookieName = "m2mRomanBlindChoices";

type M2MCookieName =
  | typeof m2mCurtainsCookieName
  | typeof m2mRomanBlindsCookieName;

export function getConfigFromCurtainsCookie(): CurtainConfiguration | null {
  const cookieValue = getCookie(m2mCurtainsCookieName);
  if (!cookieValue || cookieValue.length < 7) {
    return null;
  }

  return {
    lengthOfTrackOrPole: parseFloat(cookieValue[0] || ""),
    eyeDrop: parseFloat(cookieValue[1] || ""),
    typeOfCurtain: cookieValue[2] || "",
    liningColour: cookieValue[3] || "",
    liningWeight: (cookieValue[4] as LiningWeight) || "",
    headingType: (cookieValue[5] as HeadingType) || "",
    eyeletColour: cookieValue[6] || "",
  };
}

export function getConfigFromRomanBlindsCookie(): RomanBlindConfiguration | null {
  const cookieValue = getCookie(m2mRomanBlindsCookieName);
  if (!cookieValue || cookieValue.length < 7) {
    return null;
  }

  return {
    height: parseFloat(cookieValue[0] || ""),
    width: parseFloat(cookieValue[1] || ""),
    stackingStyle: (cookieValue[2] as StackingStyle) || "",
    liningColour: cookieValue[3] || "",
    liningWeight: (cookieValue[4] as LiningWeight) || "",
    controlSide: cookieValue[5] || "",
    installationHeight: parseFloat(cookieValue[6] || ""),
  };
}

export function setCurtainsCookieFromConfig(config: CurtainConfiguration) {
  if (!config) {
    return;
  }
  const cookieValue = `${config?.lengthOfTrackOrPole};${config?.eyeDrop};${config?.typeOfCurtain};${config?.liningColour};${config?.liningWeight};${config?.headingType};${config?.eyeletColour ? config?.eyeletColour : M2M_CURTAINS_DEFAULT_EYELET_COLOUR}`;
  setCookie(m2mCurtainsCookieName, cookieValue);
}

export function setRomanBlindsCookieFromConfig(
  config: RomanBlindConfiguration,
) {
  if (!config) {
    return;
  }
  const cookieValue = `${config?.height};${config?.width};${config?.stackingStyle};${config?.liningColour};${config?.liningWeight};${config?.controlSide};${config?.installationHeight}`;
  setCookie(m2mRomanBlindsCookieName, cookieValue);
}

function getCookie(cookieName: M2MCookieName) {
  if (typeof window !== "undefined") {
    const encodedCookie = cookies.get(cookieName);
    try {
      if (encodedCookie) {
        return window.atob(encodedCookie).split(";");
      }
    } catch (err) {
      return null;
    }
  }
  return null;
}

function setCookie(cookieName: M2MCookieName, cookieValue: string) {
  if (
    cookieName &&
    cookieValue &&
    storageCanBeSet(storageManifest.cookie[cookieName])
  ) {
    cookies.set(cookieName, window.btoa(cookieValue), {
      path: "/",
      expires: 365,
      secure: true,
    });
  }
}
